<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Details</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <v-text-field
        outlined
        dense
        v-model="model.label"
        type="text"
        label="Name"
        @keyup="changedModel"
      />
      <v-textarea
        outlined
        dense
        v-model="model.description"
        type="text"
        label="Description"
        @keyup="changedModel"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { isEqual } from 'lodash'

export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      model: {}
    }
  },
  watch: {
    product() {
      this.original = { ...this.product }
      this.model = { ...this.original }
    }
  },
  mounted() {
    this.original = { ...this.product }
    this.model = { ...this.original }
  },
  methods: {
    changedModel() {
      if (!isEqual(this.original, this.model)) {
        this.$emit('change', { ...this.model })
      }
    }
  }
}
</script>
